<template>
  <v-flex>
    <v-card color="white" class="rounded">
      <v-card-title class="mb-0">
        <h4 class="subheading">Auto Ovations Assignment</h4>
        <h3 class="section-title caption">
          Ovations can be auto assign based on the following events
        </h3>
      </v-card-title>
      <v-card-text>
        <div>
          <template>
            <v-data-table
              :headers="headers"
              :items="ovationAssignments"
              :loading="loading"
              item-key="eventName"
              sort-by="eventName"
              hide-actions
              class="elevation-1"
            >
              <template v-slot:progress>
                <v-progress-linear
                  color="#d13b55"
                  height="2"
                  indeterminate
                ></v-progress-linear>
              </template>

              <template v-slot:items="props">
                <td>
                  {{ formatEventName(props.item.eventName) }}
                </td>
                <td>
                  <v-text-field
                    type="number"
                    :rules="amountRules"
                    :min="1"
                    v-model="props.item.ovationAmount"
                    placeholder="Enter Ovation Amount"
                  ></v-text-field>
                </td>
                <td>
                  <v-checkbox
                    color="green lighten-2"
                    class="mt-4"
                    v-model="props.item.isActive"
                  ></v-checkbox>
                </td>
                <td>
                  <v-btn
                    icon
                    @click.stop="saveOvationAssignments(props.item)"
                    :disabled="loading"
                  >
                    <v-icon title="Save Ovation Assignment" color="#d13b55"
                      >mdi-content-save</v-icon
                    >
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </template>
        </div>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import axios from "axios";
import validationRules from "@/js/validationRules.js";

export default {
  name: "AutoOvationsAssignment",
  data() {
    return {
      loading: true,
      ovationAssignments: [],
      amountRules: validationRules.integerRules,
      headers: [
        { text: "Event Type", value: "eventName", sortable: false },
        { text: "Ovations to Assign", value: "ovationAmount", sortable: false },
        { text: "Active", value: "isActive", sortable: false },
        { text: "Action", value: "eventName", sortable: false },
      ],
    };
  },
  methods: {
    loadOvationAssignments: function () {
      if (
        this.$store.getters.userIsAdministrativeOrOrgOwner &&
        this.$store.getters.isCurrentOrgSet
      ) {
        this.ovationAssignments = [];
        this.loading = true;
        axios
          .get("/api/org/ovation/assignments", this.$store.state.axiosConfig)
          .then((response) => {
            this.ovationAssignments = response.data.ovationAssignments;
            this.loading = false;
          })
          .catch((e) => {
            // check/ handle 401 (Unauthorized) error
            this.$store.dispatch("error401Response", e);

            // Display Error Message
            this.$store.commit("replaceSnackbar", {
              message:
                "Error. Could not retrieved list of Ovation Assignments for the current Org.<br>Response: " +
                e.response.data.message +
                "<br>Error #KNI837",
              messageType: "error",
            });

            this.loading = false;
          });
      }
    },
    saveOvationAssignments: function (itemToSave) {
      if (
        !itemToSave.ovationAmount ||
        parseInt(itemToSave.ovationAmount) <= 0
      ) {
        this.$store.commit("replaceSnackbar", {
          message: "Ovation amount should be greater than '0'",
          messageType: "warning",
        });
        return;
      }

      this.loading = true;

      // Display Message
      this.$store.commit("replaceSnackbar", {
        message: "Saving ovation assignment...",
        messageType: "warning",
      });

      itemToSave.ovationAmount = parseInt(itemToSave.ovationAmount);

      axios
        .post(
          "/api/org/ovation/assignment",
          itemToSave,
          this.$store.state.axiosConfig
        )
        .then((response) => {
          this.ovationAssignments = response.data.ovationAssignments;
          this.loading = false;

          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: "Ovation assignment has been saved",
          });
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);
          this.loading = false;
          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Ovation assignment was NOT saved.<br>Response: " +
              e.response.data.message,
            messageType: "error",
          });
        });
    },
    formatEventName: function (eventName) {
      if (!eventName) return "";

      if (eventName === "StartDate") {
        return "Anniversary";
      } else if (eventName === "Anniversary3") {
        return "Anniversary (3 Years)";
      } else if (eventName === "Anniversary5") {
        return "Anniversary (5 Years)";
      } else if (eventName === "Anniversary7") {
        return "Anniversary (7 Years)";
      } else if (eventName === "Anniversary10") {
        return "Anniversary (10 Years)";
      } else if (eventName === "Anniversary15") {
        return "Anniversary (15 Years)";
      } else if (eventName === "Anniversary20") {
        return "Anniversary (20 Years)";
      } else if (eventName === "Anniversary25") {
        return "Anniversary (25 Years)";
      } else {
        return eventName;
      }
    },
  },
  beforeMount() {
    this.loadOvationAssignments();
  },
  watch: {
    // Update the ovation assignment list if org changed/created
    "$store.state.userSelf.currentOrg.org": function () {
      this.loadOvationAssignments();
    },
  },
};
</script>
